import React from 'react'
import { connect, getIn } from 'formik'

class ErrorFocus extends React.Component {
  componentDidUpdate(prevProps) {
    const { isSubmitting, isValidating, errors } = prevProps.formik
    const keys = Object.keys(errors)
    if (keys.length > 0 && isSubmitting && !isValidating) {
      const partSelector = this.mappingString(this.getInKeys(errors))
      const selector = `[name="${partSelector}"]`
      const errorElement = document.querySelector(selector)
      this.scrollSmooth(errorElement)
    }
  }

  scrollSmooth(errorElement) {
    const yOffset = -130
    const y =
      errorElement.getBoundingClientRect().top + window.pageYOffset + yOffset
    const isSmoothScrollSupported =
      'scrollBehavior' in document.documentElement.style
    if (isSmoothScrollSupported) {
      // not on IE/Edge
      window.scrollTo({ top: y, behavior: 'smooth' })
    } else {
      // for Edge
      document.body.scrollTop = y
      // use an offset to compensate for the fixed header
      document.documentElement.scrollTop = y
    }
    setTimeout(() => {
      errorElement.focus()
    }, 500)
  }

  getInKeys(o, keyChain = []) {
    const keys = Object.keys(o)
    const next = o[keys[0]]
    keyChain.push(keys[0])
    if (typeof next == 'object') {
      return this.getInKeys(next, keyChain)
    }

    return keyChain
  }

  mappingString(keyChain) {
    let keyString = ''
    keyChain.forEach((key, i) => {
      if (i == 0) {
        keyString = key
      } else {
        keyString = `${keyString}[${key}]`
      }
    })
    return keyString
  }

  render() {
    return <></>
  }
}

export default connect(ErrorFocus)
